class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Add hover events for desktop only
    if (window.innerWidth >= 750) {
      this.setupHoverEvents();
    }
    
    // Handle window resize events to toggle between hover and click
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  setupHoverEvents() {
    // Get the details element
    const details = this.querySelector('details');
    const summary = details.querySelector('summary');
    const submenu = this.querySelector('.header__submenu');
    
    // Track hover state for both the menu button and dropdown content
    let isButtonHovered = false;
    let isSubmenuHovered = false;
    
    // For the main menu items
    this.addEventListener('mouseenter', () => {
      isButtonHovered = true;
      details.setAttribute('open', true);
      summary.setAttribute('aria-expanded', true);
    });
    
    this.addEventListener('mouseleave', () => {
      isButtonHovered = false;
      
      // Only close if neither the button nor submenu are hovered
      setTimeout(() => {
        if (!isButtonHovered && !isSubmenuHovered) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', false);
        }
      }, 50); // Small delay to handle transition between elements
    });
    
    // Add hover events for the submenu content
    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        isSubmenuHovered = true;
      });
      
      submenu.addEventListener('mouseleave', () => {
        isSubmenuHovered = false;
        
        // Only close if neither the button nor submenu are hovered
        setTimeout(() => {
          if (!isButtonHovered && !isSubmenuHovered) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', false);
          }
        }, 50); // Small delay to handle transition between elements
      });
    }
    
    // Add hover events to nested submenus
    const nestedDetails = this.querySelectorAll('details details');
    nestedDetails.forEach(nestedDetail => {
      const nestedSummary = nestedDetail.querySelector('summary');
      const nestedParent = nestedDetail.parentElement;
      const nestedSubmenu = nestedDetail.querySelector('.header__submenu');
      
      // Track hover state for nested menu
      let isNestedButtonHovered = false;
      let isNestedSubmenuHovered = false;
      
      nestedParent.addEventListener('mouseenter', () => {
        isNestedButtonHovered = true;
        nestedDetail.setAttribute('open', true);
        nestedSummary.setAttribute('aria-expanded', true);
      });
      
      nestedParent.addEventListener('mouseleave', () => {
        isNestedButtonHovered = false;
        
        // Only close if neither the nested button nor submenu are hovered
        setTimeout(() => {
          if (!isNestedButtonHovered && !isNestedSubmenuHovered) {
            nestedDetail.removeAttribute('open');
            nestedSummary.setAttribute('aria-expanded', false);
          }
        }, 50);
      });
      
      // Add hover events for the nested submenu content
      if (nestedSubmenu) {
        nestedSubmenu.addEventListener('mouseenter', () => {
          isNestedSubmenuHovered = true;
        });
        
        nestedSubmenu.addEventListener('mouseleave', () => {
          isNestedSubmenuHovered = false;
          
          // Only close if neither the nested button nor submenu are hovered
          setTimeout(() => {
            if (!isNestedButtonHovered && !isNestedSubmenuHovered) {
              nestedDetail.removeAttribute('open');
              nestedSummary.setAttribute('aria-expanded', false);
            }
          }, 50);
        });
      }
      
      // Prevent the nested details from toggling on click for desktop
      nestedSummary.addEventListener('click', (event) => {
        if (window.innerWidth >= 750) {
          const isLink = event.target.closest('a');
          if (!isLink) {
            event.preventDefault();
            
            // If there's a link in the summary, navigate to it
            const summaryLink = nestedSummary.getAttribute('href');
            if (summaryLink) {
              window.location.href = summaryLink;
            }
          }
        }
      });
    });
    
    // Prevent the main details from toggling on click for desktop
    summary.addEventListener('click', (event) => {
      if (window.innerWidth >= 750) {
        // For desktop, only navigate if there's a link
        const isLink = event.target.closest('a');
        if (!isLink) {
          event.preventDefault();
          
          // If there's a link in the summary, navigate to it
          const summaryLink = summary.getAttribute('href');
          if (summaryLink) {
            window.location.href = summaryLink;
          }
        }
      }
    });
  }
  
  handleResize() {
    // Only setup hover events if we're on desktop
    if (window.innerWidth >= 750) {
      this.setupHoverEvents();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
